// src/themeColors.js
const themeColors = {
  darkBlue: "#2a2132",
  deepRed:  "#631a29",
  warmRed:  "#BE3144",
  softCoral:"#9e4948",

  /* ── MISSING VALUES ───────────────────────────────────── */
  lightGray:      "#F5F5F5", // page background for Subpage
  primaryText:    "#0E0E0E", // almost‑black headings
  secondaryText:  "#4B5563", // grey body text
  /* ─────────────────────────────────────────────────────── */

  gradientFrom: "#BE3144",
  gradientTo:   "#E17564",

  textPrimary:   "#FFFFFF",
  textDark:      "#000000",
  buttonText:    "#FFFFFF",
  buttonTextHover:"#FFFFFF",
  buttonBg:      "#FFFFFF",

  /* section atmospheres — bright base colors + soft color variation (no dark crush) */
  storyBg:
    "radial-gradient(120% 90% at 0% 0%, #8f3a4e 0%, transparent 55%)," +
    "radial-gradient(90% 70% at 100% 100%, #5a1f30 0%, transparent 55%)," +
    "linear-gradient(165deg, #742437 0%, #631a29 50%, #5a1826 100%)",
  presskitBg:
    "radial-gradient(100% 80% at 100% 0%, #c87070 0%, transparent 55%)," +
    "radial-gradient(80% 70% at 0% 100%, #8a4040 0%, transparent 55%)," +
    "linear-gradient(155deg, #b35a56 0%, #9e4948 55%, #934444 100%)",
  newsBg:
    "radial-gradient(90% 70% at 15% 20%, #4a3a58 0%, transparent 55%)," +
    "radial-gradient(80% 60% at 90% 90%, #241c2c 0%, transparent 50%)," +
    "linear-gradient(160deg, #32283c 0%, #2a2132 55%, #262030 100%)",
  contactBg:
    "radial-gradient(110% 80% at 85% 10%, #8a3346 0%, transparent 55%)," +
    "radial-gradient(90% 70% at 10% 90%, #521828 0%, transparent 55%)," +
    "linear-gradient(170deg, #6e2132 0%, #631a29 50%, #5c1827 100%)",
  footerBg:
    "linear-gradient(180deg, #1f1824 0%, #1a1a1a 100%)",
};

export default themeColors;
